import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

import styles from './PackageCard.module.scss';

type PackageOption = {
  name: string;
  price: string;
  includes: { text: string; price: number; quantity?: number }[];
  discount: string;
  savings: string;
  buttons: { text: string; onClick: () => void }[];
};

export default function PackageCard({
  name,
  price,
  includes,
  discount,
  savings,
  buttons,
}: PackageOption) {
  return (
    <article className={styles.root} data-testid="packageCard">
      <div className={styles.topBar}>Save {parseFloat(discount) * 100}%</div>
      <div className={styles.content}>
        <div>
          <p className={styles.name}>
            <span>{name}</span>
            <span>£{price}</span>
          </p>
          <div className={styles.includes}>
            {includes.map((include) => (
              <p key={include.text}>
                <span>
                  {include.text}{' '}
                  {include.quantity ? `x ${include.quantity}` : ''}
                </span>
                <span>
                  £{(include.price * (include.quantity || 1)).toFixed(2)}
                </span>
              </p>
            ))}
          </div>
        </div>
        <div>
          <p className={styles.savings}>
            <span>{parseFloat(discount) * 100}% Discount</span>
            <span>Save £{savings}</span>
          </p>

          <div className={styles.buttons}>
            {buttons.map((button) => (
              <Button key={button.text} onClick={button.onClick}>
                {button.text}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}
